import {
  useWSModalCustom,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import React, { useCallback } from "react";
import { BulkActionType } from "../types";

type Props = {
  actionName: string;
  actionType: BulkActionType;
  itemCount: number;
  description?: string;
  confirmLabel?: string;
} & WSModalCustomProps<boolean>;

const ModalBackgroundBulkAction: React.FC<Props> = props => {
  const handleCancel = useCallback(() => {
    props.onClose(false);
  }, [props]);
  const handleConfirm = useCallback(() => {
    props.onClose(true);
  }, [props]);

  return (
    <WSModal
      title={props.actionName}
      onClose={() => handleCancel()}
      divider
      actions={{
        alignment: "fill",
        buttons: [
          {
            kind: "Secondary",
            label: "No, cancel",
            onClick: handleCancel,
            type: "button"
          },
          {
            kind: "Primary",
            onClick: handleConfirm,
            label:
              props.confirmLabel ?? `Yes, ${props.actionName.toLowerCase()}`
          }
        ]
      }}
    >
      <WSList gap="M">
        <WSText.ParagraphSm color="gray500">
          {props.description ??
            `Are you sure you want to ${props.actionName.toLowerCase()} ${props.itemCount.toLocaleString()} items?`}
        </WSText.ParagraphSm>
      </WSList>
    </WSModal>
  );
};

export const useModalBackgroundBulkAction = () =>
  useWSModalCustom(ModalBackgroundBulkAction);
